<template>
<ion-app main>
  <ion-header>
    <ion-toolbar color="primary">
      <ion-buttons slot="end">
        <ion-button @click="cerrar">
          <i class="icon ion-ios-close-circle-outline"></i>
        </ion-button>
      </ion-buttons>
      <ion-title>Seleccionar cliente ({{clientes.length}})</ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content>
    <ion-searchbar placeholder="Buscar por nombre, email o RFC" v-on:ionChange="filtrar($event.detail.value)" debounce="500"></ion-searchbar>
    <ion-list>
      <ion-item v-if="mostrarItemTodos" v-on:click="seleccionarCliente({_id:'',nombre:'TODOS'})">
        <ion-label>
          <h2>TODOS los clientes</h2>
        </ion-label>
      </ion-item>
      <ion-item v-for="e in clientesFiltrados" :key="e._id" @click="seleccionarCliente(e)">
        <ion-label>
          <h2>{{e.nombre}}</h2>
          <p>{{e.rfc}} {{e.email}}</p>
          <p v-if="e.fecha">{{e.fecha | moment('MMM DD YYYY')}}</p>
        </ion-label>
      </ion-item>
    </ion-list>
  </ion-content>
</ion-app>
</template>

<script>
import Api from '@/components/Api/Api'
export default {
  name: 'ModalSeleccionarCliente',
  props: {
    clientes: {
      type: Array,
      default: function() {
        return []
      }
    },
    mostrarItemTodos: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      yo: Api.fetchLocal('cmms.yo') || {},
      clientesFiltrados: []
    }
  },
  methods: {
    openEnd() {
      Api.$emit('open-menu')
    },
    cerrar() {
      console.log("$emit cerrarModal")
      Api.$emit('ModalSeleccionarClienteCerrar')
    },
    seleccionarCliente(e) {
      Api.$emit('seleccionarCliente', e)
    },
    filtrar(str) {
      str = (str || '').toUpperCase()
      this.clientesFiltrados = this.clientes
        .filter(e => {
          let params = ['nombre', 'direccion', 'calle', 'telefono', 'telefonos', 'email', 'rfc']
          let strC = ''
          for (let p of params)
            if (e[p] && e[p] != '')
              strC += e[p]
          strC = strC.toUpperCase()
          return strC.indexOf(str) >= 0
        })
        .sort((a, b) => (a.nombre || '').toUpperCase() > (b.nombre || '').toUpperCase() ? 1 : -1)
    }
  },
  async mounted() {
    console.log("ModalSeleccionarCliente", this.clientes.length)
    this.filtrar('')
  }
}
</script>
